import { Component, OnInit } from '@angular/core';
import { AngularFirestore, DocumentReference } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';
import { DialogService } from 'src/app/shared/services/dialog.service';
import * as firebase from 'firebase';
import { AngularFireFunctions } from '@angular/fire/functions';

class venta {
  usuarioId: string = '';
  usuarioEmail: string = '';
  usuarioNombre: string = '';
  usuarioTipo: string = '';
  cursoId: string = '';
  cursoTitulo: string = '';
  cursoPrecioOriginal: number = 0;
  cursoPorcentajeDescuento: number = 0;
  cursoPrecioFinal: number = 0;
  transaccionMoneda: string = '';
  transaccionTax: number = 0;
  transaccionComisionCobro: number = 0;
  transaccionFecha: Date = new Date;
  transaccionEstatusCobro: string = '';
  transaccionViaCobro: string = '';
  transaccionId: string = '';
  transaccionComentario: string = '';
  instructorId: string = '';
  instructorNombre: string = '';
  instructorPorcentaje: number = 0;
  instructorTotal: number = 0;
  instructorEstatusPago: string = '';
  instructorFechaPago: any = "";
  instructorViaPago: string = '';
  pagoId: string = '';
  last4: string = "";
}  

class compra {
  usuarioId: string = '';
  usuarioEmail: string = '';
  usuarioNombre: string = '';
  usuarioTipo: string = '';
  cursoTitulo: string = '';
  cursoPrecioOriginal: number = 0;
  cursoPorcentajeDescuento: number = 0;
  cursoPrecioFinal: number = 0;
  transaccionMoneda: string = '';
  transaccionTax: number = 0;
  transaccionFecha: any;
  transaccionEstatusCobro: string = '';
  transaccionViaCobro: string = '';
  transaccionId: string = '';
  transaccionComentario: string = '';
  instructorNombre: string = '';
}

@Component({
  selector: 'venta-manual',
  templateUrl: './venta-manual.component.html',
  styleUrls: ['./venta-manual.component.css']
})
export class VentaManualComponent implements OnInit {

  usuarioIdInput: boolean = false;
  venta: venta = new venta(); // array de tipo venta

  //
  indiceUsuarios: any[] = [];
  usuario: any;
  usuarioCompra: compra = new compra();

  //
  indiceCursos: any[] = [];
  curso: any;

  // pagoRegistrado
  pagoRegistrado = false
  docRef: DocumentReference;

  constructor(
    public dialogService: DialogService,
    private afs: AngularFirestore,
    private functions: AngularFireFunctions
  ) { }

  async ngOnInit() {
    await this.getIndiceUsuario();
    await this.getIndiceCursos();
  }

  async getIndiceUsuario() {
    const doc = await this.afs.collection("global").doc("indiceUsuarios").ref.get();
    const indice = JSON.parse(JSON.stringify(doc.data()));
    Object.keys(indice).forEach((key) => {
      this.indiceUsuarios = this.indiceUsuarios.concat(indice[key])
    })
    console.log(this.indiceUsuarios)
    this.indiceUsuarios.sort((a, b) => a.email.localeCompare(b.email));
  }

  async getIndiceCursos() {
    const doc = await this.afs.collection("global").doc("indiceCursos").ref.get();
    const indice = JSON.parse(JSON.stringify(doc.data()));
    Object.keys(indice).forEach((key) => {
      this.indiceCursos = this.indiceCursos.concat(indice[key])
    })
    this.indiceCursos.sort((a, b) => a.titulo.localeCompare(b.titulo))
  }

  buscar() {
    this.usuarioIdInput = true
  }

  formatter = (x: { email: string }) => x.email;
  formatterCursos = (x: { titulo: string }) => x.titulo;
  search = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 0 ? []
        : this.indiceUsuarios.filter(v => v.email.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )

  searchCursos = (text$: Observable<string>) =>
    text$.pipe(
      debounceTime(200),
      distinctUntilChanged(),
      map(term => term.length < 0 ? []
        : this.indiceCursos.filter(v => v.titulo.toLowerCase().indexOf(term.toLowerCase()) > -1).slice(0, 10))
    )



  registrarVenta() {
    this.previewVentas()
    this.pagoRegistrado = true;
  }

  async previewVentas() {
    this.docRef = this.afs.collection("stripe_ventas").doc().ref
    this.venta.usuarioId = this.usuario.uid;
    this.venta.usuarioEmail = this.usuario.email;
    this.venta.usuarioNombre = this.usuario.nombreCompleto;
    this.venta.cursoId = this.curso.id;
    this.venta.cursoTitulo = this.curso.titulo;
    this.venta.cursoPrecioOriginal = this.curso.precioOriginal;
    this.venta.cursoPrecioFinal = +(this.curso.precioOriginal * (1 - (this.venta.cursoPorcentajeDescuento / 100))).toFixed(2);
    this.venta.transaccionId = this.docRef.id;
    this.venta.transaccionFecha = new Date;
    this.venta.instructorId = this.curso.instructorId;
    this.venta.instructorNombre = this.curso.instructorNombre;
    this.venta.instructorPorcentaje = this.curso.instructorPorcentaje;
    this.venta.instructorTotal = this.venta.cursoPrecioFinal * (this.venta.instructorPorcentaje / 100);
    this.venta.instructorEstatusPago = 'pendiente';
    this.venta.instructorFechaPago = "";
    this.venta.instructorViaPago = "";
    this.venta.pagoId = "";
  }

  async setVentas() {
    // this.venta = JSON.parse(JSON.stringify(this.venta))
    await this.docRef.set({
      usuarioId: this.usuario.uid,
      usuarioEmail: this.usuario.email,
      usuarioNombre: this.usuario.nombreCompleto,
      cursoId: this.curso.id,
      cursoTitulo: this.curso.titulo,
      cursoPrecioOriginal: this.curso.precioOriginal,
      cursoPrecioFinal: +(this.curso.precioOriginal * (1 - (this.venta.cursoPorcentajeDescuento / 100))).toFixed(2),
      transaccionId: this.docRef.id,
      transaccionFecha: new Date,
      instructorId: this.curso.instructorId,
      instructorNombre: this.curso.instructorNombre,
      instructorPorcentaje: this.curso.instructorPorcentaje,
      instructorTotal: this.venta.cursoPrecioFinal * (this.venta.instructorPorcentaje / 100),
      instructorEstatusPago: 'pendiente',
      instructorFechaPago: "",
      instructorViaPago: "",
      pagoId: "",
      usuarioTipo: this.venta.usuarioTipo,
      cursoPorcentajeDescuento: this.venta.cursoPorcentajeDescuento,
      transaccionMoneda: this.venta.transaccionMoneda,
      transaccionTax: this.venta.transaccionTax,
      transaccionComisionCobro: this.venta.transaccionComisionCobro,
      transaccionEstatusCobro: this.venta.transaccionEstatusCobro,
      transaccionViaCobro: this.venta.transaccionViaCobro,
      transaccionComentario: this.venta.transaccionComentario,
    }).catch(error => console.log(error));
    await this.afs.collection("usuariosCompras").doc(this.venta.transaccionId)
      .set({
        usuarioId: this.venta.usuarioId,
        usuarioEmail: this.venta.usuarioEmail,
        usuarioNombre: this.venta.usuarioNombre,
        usuarioTipo: this.venta.usuarioTipo,
        cursoTitulo: this.venta.cursoTitulo,
        cursoPrecioOriginal: this.venta.cursoPrecioOriginal,
        cursoPorcentajeDescuento: this.venta.cursoPorcentajeDescuento,
        cursoPrecioFinal: this.venta.cursoPrecioFinal,
        transaccionMoneda: this.venta.transaccionMoneda,
        transaccionTax: this.venta.transaccionTax,
        transaccionFecha: this.venta.transaccionFecha,
        transaccionEstatusCobro: this.venta.transaccionEstatusCobro,
        transaccionViaCobro: this.venta.transaccionViaCobro,
        transaccionId: this.venta.transaccionId,
        transaccionComentario: this.venta.transaccionComentario,
        instructorNombre: this.venta.instructorNombre,
      })
      .catch(error => console.log(error));
    this.crearProgreso()
  }

  async crearProgreso() {
    const sesionDoc = await this.afs.collection("sesiones").doc(this.venta.cursoId).ref.get();
    const sesionData = sesionDoc.data();
    const sesionClases: any[] = sesionData["clases"];
    let progresoClases = [];
    for (let index = 0; index < sesionClases.length; index++) {
      const clase = sesionClases[index];
      const obj = {
        tipo: clase.tipo,
        titulo: clase.titulo,
        duracion: clase.duracion,
        archivos: clase.archivos,
        descripcion: clase.descripcion,
        id: clase.id,
        HTMLcontent: clase.HTMLcontent,
        idVideo: clase.idVideo,
        numero: clase.numero,
        vigente: clase.vigente,
        completado: 0,
      };
      if (obj.vigente == true) {
        progresoClases = progresoClases.concat(obj);
      }
    }
    progresoClases.sort((a: any, b: any) => a.numero - b.numero);
    const valoracion = {
      global: 0,
      material: 0,
      conocimientos: 0,
      instructor: 0,
      plataforma: 0,
      comentario: "",
      fecha: new Date,
      completado: false,
    };
    await this.afs.collection("usuariosProgresos").doc(this.usuario.uid +"-"+ this.venta.cursoId).set({
      usuarioId: this.venta.usuarioId,
      cursoId: this.venta.cursoId,
      clases: progresoClases,
      certificado: "",
      completado: false,
      puntaje: 0,
      valoracion: valoracion,
      valorado: false,
      ultimoIntento: "",
    })
    await this.afs.collection("cursos").doc(this.venta.cursoId).update({
      "cantVentas": firebase.default.firestore.FieldValue.increment(1),
    }).catch(error => console.log(error))
    if (this.curso.empresaId != "") {
      console.log(this.curso.empresaId)
      await this.afs.collection("empresas").doc(this.curso.empresaId).update({
        "cantVentas": firebase.default.firestore.FieldValue.increment(1),
      }).catch(error => console.log(error))
    }
    await this.afs.collection("instructores").doc(this.venta.instructorId).update({
      "cantVentas": firebase.default.firestore.FieldValue.increment(1),
    }).catch(error => console.log(error))

    await this.afs.collection("usuarios").doc(this.venta.usuarioId).update({
      "cantCursos": firebase.default.firestore.FieldValue.increment(1),
    }).catch(error => console.log(error))

    await this.functions.httpsCallable("invoiceEmail")({
      nombre: this.venta.usuarioNombre,
      curso: this.venta.cursoTitulo,
      instructor: this.venta.instructorNombre,
      precio: this.venta.cursoPrecioFinal,
      email: this.venta.usuarioEmail,
    }).toPromise();

    this.dialogService.dialogExito();
  }

  confirmarRegistroVenta() {
    this.dialogService.dialogConfirmar().afterClosed().subscribe(res => {
      if (res == true) {
        this.registrarVenta();
      }
    })
  }



}
